import { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './button';

interface ConfirmActionProps {
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export function ConfirmAction({
  title,
  message,
  onConfirm,
  onCancel,
  loading,
}: ConfirmActionProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-5">
      <div className="hyphens-auto font-bold">{title}</div>

      <div className="text-base-content/70 hyphens-auto">{message}</div>

      <div className="flex gap-4 mt-2">
        <button className="btn btn-neutral btn-lg flex-1" onClick={onCancel}>
          {t('No')}
        </button>

        <Button className="btn btn-error btn-lg flex-1" onClick={onConfirm} loading={loading}>
          {t('Yes')}
        </Button>
      </div>
    </div>
  );
}
